export const GALLERIES_DEFAULT_SORT = Object.freeze({
  label: 'Recently Created',
  value: 'CREATED',
});

export const DETAIL_DEFAULT_SORT = Object.freeze({
  label: 'Recently Published',
  value: 'DATE',
});

export const BOARDS_DRAWERS = Object.freeze({
  CREATE_BOARD: 'createBoard',
  DETAIL: 'boardDetail',
  GALLERY_REORDER: 'galleryReorder',
});

export const TOAST_MESSAGES = Object.freeze({
  BOARD_CREATED: 'Board Created',
  BOARD_CREATED_ERROR: 'There was an error creating your board. Please try again.',
  BOARD_UPDATED: 'Board Updated',
  BOARD_UPDATED_ERROR: 'There was an error updating your board. Please try again.',
  BOARD_CREATED_DUPLICATE_NAME: (name) =>
    `A board with the name "${name}" already exists, please choose a new name for your board.`,
  MEDIA_ADDED: 'Media Added',
  MEDIA_ADDED_ERROR: 'There was an error while adding media to your board. Please try again.',
});

export const LIBRARY_GALLERY_STATE_FILTER_OPTIONS = [
  {
    label: 'Shoppable',
    value: 'shoppable',
  },
  {
    label: 'Non Shoppable',
    value: 'nonShoppable',
  },
];

export const LIVE_TOOLTIP = 'This gallery is enabled and has received traffic in the past 7 days';
export const NOT_LIVE_TOOLTIP =
  'This gallery is enabled but has not received traffic in the past 7 days';

export const onsiteBannerMessage =
  'On-Site Galleries create a media carousel or grid to showcase UGC or owned content on your website. Add the provided code, and Dash will automatically display the most recently added media. Note: Changes made in the Customize section won’t update on your site after embedding.';
export const urlBannerMessage =
  'A URL Gallery is a custom webpage designed to let creators showcase their favorite products in a curated gallery.';
export const emailBannerMessage =
  'The process of integrating your gallery into an email template depends on your CMS.';
export const tooltipEnableLinks =
  'Controls what happens when someone clicks on a piece of media. When enabled, clicks will open the assigned product links. When disabled, media will not be clickable.';
export const tooltipDisplayPrice =
  'Controls whether price appears on the media popup. Price and currency are pulled from the connected product feed.';
export const tooltipOriginalRes =
  'Controls how media is displayed. When enabled, media appears in its original aspect ratio and resolution instead of a 1:1 crop.';
export const tooltipGalleryState =
  'Galleries marked as Shoppable can be embedded on your website to showcase and link products. Customize this setting inside the gallery.';
export const shopLearnMoreLinkOnsite =
  'https://help.dashsocial.com/hc/en-us/articles/4411349410573-Setting-Up-Shoppable-Galleries';
export const shopLearnMoreLinkEmail =
  'https://help.dashsocial.com/hc/en-us/articles/4411349410573-Setting-Up-Shoppable-Galleries#h_01H9V4QSB8S9JKHQNBENBJXPFB';
export const widgetCustomizationGuide =
  'https://developer.dashsocial.com/docs/shoppable-galleries-doc';

export const boardsIndexDefaultFilters = Object.freeze({
  reportingPeriod: { preset: 'ALL_TIME' },
  search: null,
  sort: {
    sortOrder: 'DESC',
    selected: GALLERIES_DEFAULT_SORT,
  },
  tags: [],
  tagsFilterType: 'OR',
});

export const boardsIndexQueryParamMapping = Object.freeze({
  'reportingPeriod.range.start': { queryParamName: 'startDate', type: 'date' },
  'reportingPeriod.range.end': { queryParamName: 'endDate', type: 'date' },
  'sort.selected.value': { queryParamName: 'sort', type: 'string' },
  'sort.sortOrder': { queryParamName: 'sortOrder', type: 'string' },
  tags: { queryParamName: 'tags', type: 'array', elementType: 'number' },
  tagsFilterType: { queryParamName: 'tagsFilterType', type: 'string' },
});

export const libraryGalleriesDefaultFilters = Object.freeze({
  search: null,
  galleryState: [],
  sort: {
    sortOrder: 'DESC',
    selected: GALLERIES_DEFAULT_SORT,
  },
  tags: [],
  tagsFilterType: 'OR',
});

export const libraryGalleriesQueryParamMapping = Object.freeze({
  galleryState: { queryParamName: 'galleryState', type: 'array', elementType: 'string' },
  'sort.selected.value': { queryParamName: 'sort', type: 'string' },
  'sort.sortOrder': { queryParamName: 'sortOrder', type: 'string' },
  tags: { queryParamName: 'tags', type: 'array', elementType: 'number' },
  tagsFilterType: { queryParamName: 'tagsFilterType', type: 'string' },
});

export const galleriesDefaultSort = Object.freeze({
  sortOrder: 'DESC',
  selected: GALLERIES_DEFAULT_SORT,
});

export const boardDetailDefaultSort = Object.freeze({
  sortOrder: 'DESC',
  selected: DETAIL_DEFAULT_SORT,
});
